module.exports = "<md-card class=\"mt-double mat-card\" *ngIf=\"entityIdDetails\">\n  <iframe style=\"height: 600px\" [src]=\"safeUrl()\" class=\"iframeStyle\"></iframe>\n</md-card>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/workflow/workflow/workflow.component.html
// module id = 2355
// module chunks = 0